class ToggleTab {
  constructor(toggleContainer) {
    this.toggleConatiner = document.querySelector(toggleContainer);
    this.toggleElement = null;
    this.toggleOverlay = null;
    this.toggleButton = null;
  }

  init() {
    if (this.toggleConatiner) {
      this.toggleElement = this.toggleConatiner.querySelector('.js-description-show-more-content');
      this.toggleOverlay = this.toggleConatiner.querySelector('.js-description-show-more-overlay');
      this.toggleButton = this.toggleConatiner.querySelector('.js-description-show-more-button');
      this.toggleButtonOff = this.toggleConatiner.querySelector('.js-description-show-less-button');
      this.toggleEvent();
      this.toggleEventOff();
    }
  }

  toggleEvent() {
    if (this.toggleButton) {
      this.toggleButton.addEventListener('click', () => {
        this.toggleOverlay.classList.remove('animated', 'fadeIn');
        this.toggleOverlay.classList.add('tab-overlay-none');
        this.toggleElement.classList.add('tab-content-full', 'animated', 'fadeInUp');
      })
    }
  }

  toggleEventOff() {
    if (this.toggleButtonOff) {
      this.toggleButtonOff.addEventListener('click', () => {
        this.toggleOverlay.classList.remove('tab-overlay-none');
        this.toggleOverlay.classList.add('animated', 'fadeIn');
        this.toggleElement.classList.remove('tab-content-full', 'animated', 'fadeInUp');
      })
    }
  }
}

export default ToggleTab;


// WEBPACK FOOTER //
// ./scripts/modules/toggle-visibility-tab.js